/* eslint-disable */
import * as Types from '../../../models/schema';

import { MainGrapeFragmentDTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type UpdateMainGrapeVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
  data: Types.MainGrapeUpdateInputDTO;
}>;


export type UpdateMainGrapeDTO = (
  { __typename?: 'Mutation' }
  & { updateOneMainGrape: (
    { __typename?: 'MainGrape' }
    & MainGrapeFragmentDTO
  ) }
);


export const UpdateMainGrapeDocumentDTO = gql`
    mutation updateMainGrape($id: String!, $data: MainGrapeUpdateInput!) {
  updateOneMainGrape(id: $id, data: $data) {
    ...mainGrapeFragment
  }
}
    ${MainGrapeFragmentDTO}`;
export type UpdateMainGrapeMutationFnDTO = Apollo.MutationFunction<UpdateMainGrapeDTO, UpdateMainGrapeVariablesDTO>;

/**
 * __useUpdateMainGrape__
 *
 * To run a mutation, you first call `useUpdateMainGrape` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMainGrape` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMainGrape, { data, loading, error }] = useUpdateMainGrape({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMainGrape(baseOptions?: Apollo.MutationHookOptions<UpdateMainGrapeDTO, UpdateMainGrapeVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMainGrapeDTO, UpdateMainGrapeVariablesDTO>(UpdateMainGrapeDocumentDTO, options);
      }
export type UpdateMainGrapeHookResult = ReturnType<typeof useUpdateMainGrape>;
export type UpdateMainGrapeMutationResultDTO = Apollo.MutationResult<UpdateMainGrapeDTO>;
export type UpdateMainGrapeMutationOptionsDTO = Apollo.BaseMutationOptions<UpdateMainGrapeDTO, UpdateMainGrapeVariablesDTO>;